/**
 * MetalliCSS Initialization Script
 * Adds enhanced styling class once MetalliCSS is loaded
 */

(function() {
  // Add enhanced class to all MetalliCSS buttons when library loads
  function enhanceMetallicButtons() {
    const metallicButtons = document.querySelectorAll('.metallicss');
    
    metallicButtons.forEach(button => {
      button.classList.add('metalli-enhanced');
    });
  }

  // Wait for MetalliCSS library to load
  function waitForMetalliCSS() {
    if (typeof window.MetalliCSS !== 'undefined' && window.MetalliCSS.init) {
      // Initialize MetalliCSS
      window.MetalliCSS.init();
      
      // Add enhanced class after a short delay to ensure MetalliCSS has applied its effects
      setTimeout(enhanceMetallicButtons, 100);
    } else {
      // Retry after a short delay
      setTimeout(waitForMetalliCSS, 50);
    }
  }

  // Start checking for MetalliCSS when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForMetalliCSS);
  } else {
    waitForMetalliCSS();
  }

  // Re-enhance buttons when sections are reloaded (theme editor)
  document.addEventListener('shopify:section:load', () => {
    setTimeout(enhanceMetallicButtons, 150);
  });

  // Also enhance dynamically added buttons (cart drawer, etc.)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Check if the node itself or its children have metallicss class
          const newButtons = node.classList?.contains('metallicss') 
            ? [node] 
            : node.querySelectorAll?.('.metallicss') || [];
          
          if (newButtons.length > 0) {
            setTimeout(() => {
              newButtons.forEach(button => {
                if (typeof window.MetalliCSS !== 'undefined' && window.MetalliCSS.init) {
                  button.classList.add('metalli-enhanced');
                }
              });
            }, 100);
          }
        }
      });
    });
  });

  // Start observing the document for new buttons
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
})();

